import PropTypes from 'prop-types';
import { Button, Grid, GridItem } from '@bwoty-web/ui-kit';

import FakeUi from '../../shared/loaders/FakeUi';

import './roomCardListLoader.scss';

const RoomCardListLoader = ({ isHotelOnly }) => (
  <Grid>
    {Array.from({ length: 3 }).map((_, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <GridItem columnSpan={4} key={idx}>
        <div className="price-matrix-table-loader__room-card">
          {!isHotelOnly && (
            <div className="price-matrix-table-loader__room-card-image">
              <FakeUi />
            </div>
          )}
          <div className="price-matrix-table-loader__room-card-content">
            <div className="price-matrix-table-loader__room-card-title">
              <FakeUi />
            </div>
            <div className="price-matrix-table-loader__room-card-description">
              <FakeUi />
            </div>
            <div className="price-matrix-table-loader__room-card-bullets">
              <FakeUi />
            </div>
            <div className="price-matrix-table-loader__room-card-ksps">
              <FakeUi />
            </div>
          </div>
          <div className="price-matrix-table-loader__room-card-footer">
            <div className="price-matrix-table-loader__room-card-footer-price">
              <FakeUi />
            </div>
            <div className="price-matrix-table-loader__room-card-footer-btn">
              <Button disabled>
                <span />
              </Button>
            </div>
          </div>
        </div>
      </GridItem>
    ))}
  </Grid>
);

RoomCardListLoader.propTypes = {
  isHotelOnly: PropTypes.bool,
};

RoomCardListLoader.defaultProps = {
  isHotelOnly: false,
};

export default RoomCardListLoader;
